<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="row exportarReservas" v-if="listConfig.cruzcampo">
          <div class="pedidosContainerButtonery">
            <el-dropdown>
              <el-button type="primary" size="small">
                <i class="fa fa-file"></i>
                {{ $t("exportarReservas") }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <a :href="urlExportExcel">
                  <el-dropdown-item class="text-success">
                    <strong
                      ><i class="fa fa-file-excel"></i>
                      {{ $t("exportarExcel") }}</strong
                    >
                  </el-dropdown-item>
                </a>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="row buttoneryHeader">
          <div class="col-md-4">
            <div class="form-group">
              <label for="listBusiness"
                ><strong>{{ $t("negocio") }}</strong></label
              >

              <el-select
                class="select-default"
                size="large"
                v-model="idBusiness"
                filterable
                @change="cambioOpcionBusiness()"
                :placeholder="this.$i18n.t('seleccionaNegocio')"
              >
                <el-option
                  v-for="business in listBusinesses"
                  class="select-primary"
                  :value="business.id"
                  :label="business.establishmentName"
                  :key="business.id + business.establishmentName"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="pedidosContainerButtonery col-md-8">
            <div class="row form-group">
               <button class="btn btn-primary mr-3" v-if="estadio"
                  style="color: white;"
                  @click="$modal.show('modal-exportar-partido')">
                <span
                ><i class="fa-solid fa-file-arrow-down"></i> Exportar informe de partido</span>
              </button>
              <button
                v-if="user.isAdmin && listResumenAgencias.length > 0"
                class="btn btn-primary mr-3"
                @click="$modal.show('modal-resumen-agencias')"
              >
                <span
                  >Resumen por agencias</span
                >
              </button>
              <button class="btn btn-primary mr-3">
                <router-link
                  style="color: white;"
                  :to="{ name: 'pedidos-archivados' }"
                >Ver pedidos archivados</router-link>
              </button>
              <button
                v-if="user.isAdmin && listPedidoLimbo.length > 0"
                class="btn btn-danger ebtnLimbo"
                @click="$modal.show('modal-limbo')"
              >
                <span
                  >Pedidos sin completar ({{ listPedidoLimbo.length }})</span
                >
              </button>
              <button
                @click="getPedidos(), (contador = 30)"
                class="btn btn-primary ebtnLimbo ebtnPedidos"
                v-bind:style="listPedidoLimbo.length <= 0 && movil ? 'width: 90%': '' "
              >
                <i class="fas fa-sync"></i>&nbsp;{{ $t("actualizarPedidos") }} ({{
                  contador
                }})
              </button>
            </div>
          </div>
        </div>

        <!--NO MOSTRAR PEDIDOS-->
        <div class="row">
          <template v-if="permiso && respuesta">
            <!-- AQUI -->
            
              <button class="btn btnIcon">
                <i class="fas fa-shopping-bag" style="color:#3c3c3c; cursor: context-menu"></i>
              </button>
              <div class="buttoneryTime" >
                <input v-model="configuracionCarta.takeawaytime" class="form-control" id="nombreProducto"  readonly="readonly" style="background-color:white; cursor: context-menu; border-radius: 0%; border: 1px solid #D3D3D3;"> 
                 <!-- -->
              </div>
              <button class="btn btnTime" @click="restarTiempoEnvio()"  style=" border-radius: 0%">
                <i class="fas fa-chevron-down" style="color:#3c3c3c;"></i>
              </button>
              <button class="btn btnTime" @click="sumarTiempoEnvio()">
                <i class="fas fa-chevron-up" style="color:#3c3c3c;"></i>
              </button>

              <button class="btn btnIcon">
                <i class="fas fa-home" style="color:#3c3c3c; cursor: context-menu;"></i>
              </button>
              <div class="buttoneryTime" >
                <input v-model="configuracionCarta.tiempoMedio" type="text" class="form-control" id="nombreProducto" readonly="readonly" style="background-color:white; cursor: context-menu; border-radius: 0%; border: 1px solid #D3D3D3;">
              </div>
              <button class="btn btnTime" @click="restarTiempoRecoger()"  style=" border-radius: 0%">
                <i class="fas fa-chevron-down" style="color:#3c3c3c;"></i>
              </button>
              <button class="btn btnTime" @click="sumarTiempoRecoger()">
                <i class="fas fa-chevron-up" style="color:#3c3c3c;"></i>
              </button>
          <!-- ---------------------------------- -->
            <div class="btnTogglePedidosContainer">
              <div class="row botones">
                <template v-if="panelMesas" class="btnTogglePedidosItem">
                  <!-- EN EL TEXTO DEL TOGGLE NO AÑADIR ESPACIOS EN BLANCO, COPIAR CARACTER DE AQUÍ (⠀) ES EL ESPACIO BLANCO EN BRAILLE-->
                  <VueToggles
                    id="switchMesas"
                    @click="openModalCerrarMesas(servicioActivo)"
                    :value="servicioActivo"
                    height="35"
                    fontSize="14"
                    width="225"
                    fontWeight="bold"
                    :checkedText="$t('mesasActivadas')"
                    :uncheckedText="$t('mesasDesactivadas')"
                    checkedBg="#28a745"
                    uncheckedBg="lightgrey"
                  ></VueToggles>
                  <!--"MESAS⠀ACTIVADAS⠀‏‏‎""MESAS⠀DESACTIVADAS⠀"  -->
                </template>
                <template
                  v-if="listConfig.tienePedidos"
                  class="btnTogglePedidosItem"
                >
                  <!-- EN EL TEXTO DEL TOGGLE NO AÑADIR ESPACIOS EN BLANCO, COPIAR CARACTER DE AQUÍ (⠀) ES EL ESPACIO BLANCO EN BRAILLE-->
                  <VueToggles
                    id="switchPedidosDomicilio"
                    @click="
                      openModalCerrarServicio('D', !pedidosSuspendidosDomicilio)
                    "
                    :value="!pedidosSuspendidosDomicilio"
                    height="35"
                    width="225"
                    fontSize="14"
                    fontWeight="bold"
                    :checkedText="$t('domicilioActivado')"
                    :uncheckedText="$t('domicilioDesactivado')"
                    checkedBg="#28a745"
                    uncheckedBg="lightgrey"
                    v-if="!listConfig.noDomicilio"
                  ></VueToggles>
                </template>
                <template
                  v-if="listConfig.tienePedidos"
                  class="btnTogglePedidosItem"
                >
                  <VueToggles
                    id="switchPedidosRecoger"
                    @click="
                      openModalCerrarServicio('R', !pedidosSuspendidosRecoger)
                    "
                    :value="!pedidosSuspendidosRecoger"
                    height="35"
                    width="225"
                    fontSize="14"
                    fontWeight="bold"
                    :checkedText="$t('recogerActivado')"
                    :uncheckedText="$t('recogerDesactivado')"
                    checkedBg="#28a745"
                    uncheckedBg="lightgrey"
                    v-if="!listConfig.noRecoger"
                  ></VueToggles>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
      <!--NO MOSTRAR PEDIDOS-->
      <template v-if="permiso === 1"> </template>
      <template v-else-if="permiso && respuesta">
        <div class="col-md-2">
          <button
            @click="(estado = 0), getPedidos()"
            style="width: 100%"
            :class="[estado === 0 ? 'btn btnPendientes' : 'btn btnDefault']"
          >
            {{ $t("pendienteDeConfirmacion") }} ({{ numConfirmacion }})
          </button>
        </div>

        <div class="col-md-2">
          <button
            @click="(estado = 1), getPedidos()"
            style="width: 100%"
            :class="[estado === 1 ? 'btn btnConfirmados' : 'btn btnDefault']"
          >
            {{ $t("confirmados") }} ({{ numConfirmados }})
          </button>
        </div>

        <div class="col-md-2">
          <button
            @click="(estado = 2), getPedidos()"
            style="width: 100%"
            :class="[estado === 2 ? 'btn btnEnPreparacion' : 'btn btnDefault']"
          >
            {{ $t("enPreparacion") }} ({{ numPreparando }})
          </button>
        </div>

        <div class="col-md-2">
          <button
            @click="(estado = 3), getPedidos()"
            style="width: 100%"
            :class="[estado === 3 ? 'btn btnPreparados' : 'btn btnDefault']"
          >
            {{ $t("preparados") }} ({{ numPreparados }})
          </button>
        </div>

        <div class="col-md-2">
          <button
            @click="(estado = 4), getPedidos()"
            style="width: 100%"
            :class="[estado === 4 ? 'btn btnEnReparto' : 'btn btnDefault']"
          >
            {{ $t("enReparto") }} ({{ numEnReparto }})
          </button>
        </div>

        <div class="col-md-2">
          <button
            @click="(estado = 5), getPedidos()"
            style="width: 100%"
            :class="[estado === 5 ? 'btn btnFinalizados' : 'btn btnDefault']"
          >
            {{ $t("finalizados") }} ({{ numFinalizado }})
          </button>
        </div>
        <template
          v-if="
            listPedidosRecogida.length > 0 ||
              listPedidosDomicilio.length > 0 ||
              listPedidoMesa.length > 0
          "
        >
          <!--RECOGIDA-->
          <div :class="col(0)" v-if="panelRecogida">
            <div class="titlePedidos">
              <strong
                ><img width="20px" src="static/img/delivery/recoger.png" />
                {{ $t("recogida") }}</strong
              >
            </div>
            <div v-for="obj in listPedidosRecogida">
              <transition name="list">
                <item-pedido
                  v-if="obj.visto"
                  :estado="estado"
                  @openModalEliminarPedido="openModalEliminarPedido"
                  @agregarObservacion="agregarObservacion"
                  @confirmarPedido="confirmarPedido"
                  :obj="obj"
                  :tieneSinqro="tieneSinqro"
                  :listConfig="listConfig"
                  :estadio="estadio"
                ></item-pedido>
              </transition>
            </div>
          </div>

          <!--DOMICILIO-->
          <div :class="col(1)" v-if="panelRecogida">
            <div class="titlePedidos">
              <strong>
                <img width="20px" src="static/img/delivery/domicilio.png" />
                {{ $t("domicilio") }}</strong
              >
            </div>
            <div v-for="obj in listPedidosDomicilio">
              <transition name="list">
                <item-pedido
                  v-if="obj.visto"
                  @openModalEliminarPedido="openModalEliminarPedido"
                  @agregarObservacion="agregarObservacion"
                  @confirmarPedido="confirmarPedido"
                  :obj="obj"
                  :tieneSinqro="tieneSinqro"
                  :listConfig="listConfig"
                  :estadio="estadio"
                ></item-pedido>
              </transition>
            </div>
          </div>

          <!--MESAS-->
          <div :class="col(2)" v-if="panelMesas">
            <!--../../../../static/img/mesas/mesa.png-->
            <div class="titlePedidos">
              <strong><i class="fas fa-utensils"></i> {{ $t("mesas") }}</strong>
            </div>
            <div v-for="obj in listPedidoMesa">
              <transition name="list">
                <item-pedido
                  v-if="obj.visto"
                  :estado="estado"
                  @openModalEliminarPedido="openModalEliminarPedido"
                  @agregarObservacion="agregarObservacion"
                  @confirmarPedido="confirmarPedido"
                  :obj="obj"
                  :tieneSinqro="tieneSinqro"
                  :listConfig="listConfig"
                  :estadio="estadio"
                ></item-pedido>
              </transition>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="col-md-12" align="center">
            <h2>{{ textAlert }}</h2>
            <!--<div class="alert alert-danger" role="alert" style="width: 100%">-->
            <!--No hay pedidos <strong>pendientes de confirmación</strong>-->
            <!--</div>-->
          </div>
        </template>
      </template>

      <template v-if="!permiso">
        <div class="col-md-12">
          <div class=" alert alert-primary" align="center">
            <h3>
              <i class="fas fa-exclamation-circle"></i
              >{{ $t("esteNegocioNoTieneAccesoAEsteModulo") }}.
            </h3>

            <span>
              {{ $t("paraMasInformacionContacteConSu") }}
              <strong>{{ $t("distribuidor") }}</strong
              >.</span
            >
          </div>
        </div>
      </template>
    </div>
    <!-- modal pantalla web -->
    <modal v-if="screen.width > 992"
     
      name="modal-limbo"
      :adaptive="true"
      :scrollable="true"
      :overflowX ="'scroll'"
      :clickToClose="true"
      :height="'auto'"
      :width="'70%'"
    >
      <div class="modal-header">
        <h4 style="margin: 0px">{{$t("pedidosPlataformaDePagoSinCompletar")}}</h4>
        <button
          @click="$modal.hide('modal-limbo')"
          type="button"
          class="btn-close"
          style="background: none; border: none;"
          aria-label="Close"
        >
          <i class="fas fa-times fa-lg" style="color:#3c3c3c !important;"></i>
        </button>
      </div>
      <div style="overflow-x: scroll !important;">
      <table class="table table-bordered table-striped"  v-bind:class="{ 'table-sm': movil }">
        <thead class="thead-dark">
          <th class="text-center">{{$t("fecha")}}</th>
          <th class="text-center">{{$t("hash")}}</th>
          <th class="text-center">{{$t("nombre")}}</th>
          <th class="text-center">{{$t("email")}}</th>
          <th class="text-center">{{$t("importe")}}</th>
          <th class="text-center">{{$t("telefono")}}</th>
          <th class="text-center">{{$t("direccion")}}</th>
          <th class="text-center">{{$t("mesa")}}</th>
          <th class="text-center">{{$t("acciones")}}</th>
        </thead>
        <tbody>
          <tr v-for="pedido in listPedidoLimbo" :key="pedido.id">
            <td class="text-center">{{ pedido.created | parseDateMin }}</td>
            <td class="text-center">{{ pedido.hash }}</td>
            <td class="text-center">{{ pedido.clientData.nombre }}</td>
            <td class="text-center">{{ pedido.clientData.email }}</td>
            <td class="text-center">{{ pedido.total }}€</td>
            <td class="text-center">{{ pedido.clientData.telefono }}</td>
            <td class="text-center">{{ pedido.clientData.direccion1 }}</td>
            <td class="text-center">{{ pedido.clientData.tipoPedido == 'M' ? pedido.clientData.numMesa : ''}}</td>
            <td class="text-center">
              <a
                @click="gestionarTemporal(pedido, true)"
                class="btn btn-danger btn-link btn-xs"
              >
                <i
                  v-tooltip.top-center="$t('aceptar')"
                  class="fas fa-check-circle text-success"
                ></i>
              </a>

              <a
                @click="gestionarTemporal(pedido, false)"
                class="btn btn-danger btn-link btn-xs"
              >
                <i
                  v-tooltip.top-center="$t('borrar')"
                  class="fas fa-trash-alt text-danger"
                ></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </modal>
    <!-- MODAL telefono -->
    <modal v-if="screen.width < 991"
     
      name="modal-limbo"
      :adaptive="true"
      :scrollable="true"
      :overflowX ="'scroll'"
      :clickToClose="true"
      :height="'auto'"
      :width="'90%'"
    >
      <div class="modal-header">
        <h4 style="margin: 0px">{{$t("pedidosPlataformaDePagoSinCompletar")}}</h4>
        <button
          @click="$modal.hide('modal-limbo')"
          type="button"
          class="btn-close"
          style="background: none; border: none;"
          aria-label="Close"
        >
          <i class="fas fa-times fa-lg" style="color:#3c3c3c !important;"></i>
        </button>
      </div>
      <div style="overflow-x: scroll !important;">
      <table class="table table-bordered table-striped"  v-bind:class="{ 'table-sm': movil }">
        <thead class="thead-dark">
          <th class="text-center">{{$t("fecha")}}</th>
          <th class="text-center">{{$t("hash")}}</th>
          <th class="text-center">{{$t("nombre")}}</th>
          <th class="text-center">{{$t("email")}}</th>
          <th class="text-center">{{$t("importe")}}</th>
          <th class="text-center">{{$t("telefono")}}</th>
          <th class="text-center">{{$t("direccion")}}</th>
          <th class="text-center">{{$t("mesa")}}</th>
          <th class="text-center">{{$t("acciones")}}</th>
        </thead>
        <tbody>
          <tr v-for="pedido in listPedidoLimbo" :key="pedido.id">
            <td class="text-center">{{ pedido.created | parseDateMin }}</td>
            <td class="text-center">{{ pedido.hash }}</td>
            <td class="text-center">{{ pedido.clientData.nombre }}</td>
            <td class="text-center">{{ pedido.clientData.email }}</td>
            <td class="text-center">{{ pedido.total }}€</td>
            <td class="text-center">{{ pedido.clientData.telefono }}</td>
            <td class="text-center">{{ pedido.clientData.direccion1 }}</td>
            <td class="text-center">{{ pedido.clientData.tipoPedido == 'M' ? pedido.clientData.numMesa : ''}}</td>
            <td class="text-center">
              <a
                @click="gestionarTemporal(pedido, true)"
                class="btn btn-danger btn-link btn-xs"
              >
                <i
                  v-tooltip.top-center="$t('aceptar')"
                  class="fas fa-check-circle text-success"
                ></i>
              </a>

              <a
                @click="gestionarTemporal(pedido, false)"
                class="btn btn-danger btn-link btn-xs"
              >
                <i
                  v-tooltip.top-center="$t('borrar')"
                  class="fas fa-trash-alt text-danger"
                ></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </modal>
    <modal v-if="screen.width > 992"
     
      name="modal-limbo"
      :adaptive="true"
      :scrollable="true"
      :overflowX ="'scroll'"
      :clickToClose="true"
      :height="'auto'"
      :width="'70%'"
    >
      <div class="modal-header">
        <h4 style="margin: 0px">{{$t("pedidosPlataformaDePagoSinCompletar")}}</h4>
        <button
          @click="$modal.hide('modal-limbo')"
          type="button"
          class="btn-close"
          style="background: none; border: none;"
          aria-label="Close"
        >
          <i class="fas fa-times fa-lg" style="color:#3c3c3c !important;"></i>
        </button>
      </div>
      <div style="overflow-x: scroll !important;">
      <table class="table table-bordered table-striped"  v-bind:class="{ 'table-sm': movil }">
        <thead class="thead-dark">
          <th class="text-center">{{$t("fecha")}}</th>
          <th class="text-center">{{$t("hash")}}</th>
          <th class="text-center">{{$t("nombre")}}</th>
          <th class="text-center">{{$t("email")}}</th>
          <th class="text-center">{{$t("importe")}}</th>
          <th class="text-center">{{$t("telefono")}}</th>
          <th class="text-center">{{$t("direccion")}}</th>
          <th class="text-center">{{$t("mesa")}}</th>
          <th class="text-center">{{$t("acciones")}}</th>
        </thead>
        <tbody>
          <tr v-for="pedido in listPedidoLimbo" :key="pedido.id">
            <td class="text-center">{{ pedido.created | parseDateMin }}</td>
            <td class="text-center">{{ pedido.hash }}</td>
            <td class="text-center">{{ pedido.clientData.nombre }}</td>
            <td class="text-center">{{ pedido.clientData.email }}</td>
            <td class="text-center">{{ pedido.total }}€</td>
            <td class="text-center">{{ pedido.clientData.telefono }}</td>
            <td class="text-center">{{ pedido.clientData.direccion1 }}</td>
            <td class="text-center">{{ pedido.clientData.tipoPedido == 'M' ? pedido.clientData.numMesa : ''}}</td>
            <td class="text-center">
              <a
                @click="gestionarTemporal(pedido, true)"
                class="btn btn-danger btn-link btn-xs"
              >
                <i
                  v-tooltip.top-center="$t('aceptar')"
                  class="fas fa-check-circle text-success"
                ></i>
              </a>

              <a
                @click="gestionarTemporal(pedido, false)"
                class="btn btn-danger btn-link btn-xs"
              >
                <i
                  v-tooltip.top-center="$t('borrar')"
                  class="fas fa-trash-alt text-danger"
                ></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </modal>
    <modal v-if="screen.width < 991"
     
      name="modal-resumen-agencias"
      :adaptive="true"
      :scrollable="true"
      :overflowX ="'scroll'"
      :clickToClose="true"
      :height="'auto'"
      :width="'90%'"
    >
      <div class="modal-header">
        <h4 style="margin: 0px">Resumen de pedidos por agencia</h4>
        <button
          @click="$modal.hide('modal-resumen-agencias')"
          type="button"
          class="btn-close"
          style="background: none; border: none;"
          aria-label="Close"
        >
          <i class="fas fa-times fa-lg" style="color:#3c3c3c !important;"></i>
        </button>
      </div>
      <div style="overflow-x: scroll !important;">
      <table class="table table-bordered table-striped"  v-bind:class="{ 'table-sm': movil }">
        <thead class="thead-dark">
          <th class="text-center">{{$t("agencia")}}</th>
          <th class="text-center">Nº Pedidos</th>
          <th class="text-center">{{$t("total")}}</th>
        </thead>
        <tbody>
          <tr v-for="resumen in listResumenAgencias" :key="'resumenAgencia'+resumen.nombreAgencia">
            <td class="text-left pl-3" width="50%"><img style="max-width: 25px; margin-right:5px;" :src="'https://www.numier.com/img/'+resumen.nombreAgencia+'.png'"/> {{ resumen.nombreAgencia }}</td>
            <td class="text-center pl-3" width="25%">{{ resumen.numeroPedidos }}</td>
            <td class="text-right pl-3" width="25%">{{ resumen.total }} EUR</td>
          </tr>
        </tbody>
      </table>
      </div>
    </modal>
    <modal v-if="screen.width > 992"
     
      name="modal-resumen-agencias"
      :adaptive="true"
      :scrollable="true"
      :overflowX ="'scroll'"
      :clickToClose="true"
      :height="'auto'"
      :width="'50%'"
    >
      <div class="modal-header">
        <h4 style="margin: 0px">Resumen de pedidos por agencia</h4>
        <button
          @click="$modal.hide('modal-resumen-agencias')"
          type="button"
          class="btn-close"
          style="background: none; border: none;"
          aria-label="Close"
        >
          <i class="fas fa-times fa-lg" style="color:#3c3c3c !important;"></i>
        </button>
      </div>
      <div style="overflow-x: scroll !important;">
      <table class="table table-bordered table-striped"  v-bind:class="{ 'table-sm': movil }">
        <thead class="thead-dark">
          <th class="text-center">{{$t("agencia")}}</th>
          <th class="text-center">Nº Pedidos</th>
          <th class="text-center">{{$t("total")}}</th>
        </thead>
        <tbody>
          <tr v-for="resumen in listResumenAgencias" :key="'agencia'+resumen.nombreAgencia">
            <td class="text-left pl-3" width="50%"><img style="max-width: 25px; margin-right:5px" :src="'https://www.numier.com/img/'+resumen.nombreAgencia+'.png'"/> {{ resumen.nombreAgencia }}</td>
            <td class="text-center pl-3" width="25%">{{ resumen.numeroPedidos }}</td>
            <td class="text-right pl-3" width="25%">{{ resumen.total }} EUR</td>
          </tr>
        </tbody>
      </table>
      </div>
    </modal>
    <modal v-if="screen.width > 992"
     
      name="modal-exportar-partido"
      :adaptive="true"
      :scrollable="true"
      :overflowX ="'scroll'"
      :clickToClose="true"
      :height="'auto'"
      :width="'35%'"
    >
      <div class="modal-header">
        <h4 style="margin: 0px">Exportar informe por partido</h4>
        <button
          @click="$modal.hide('modal-exportar-partido')"
          type="button"
          class="btn-close"
          style="background: none; border: none;"
          aria-label="Close"
        >
          <i class="fas fa-times fa-lg" style="color:#3c3c3c !important;"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ $t("fecha") }}</label>
            <datetime
              :value-zone="timezoneId"
              :auto="true"
              class="theme-numier"
              format="dd-MM-yyyy"
              :title="$t('fecha')"
              :placeholder="'Selecciona la fecha del día del partido'"
              :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
              input-class="form-control"
              v-model="diaExportacionPartido">
            </datetime>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="col-md-3">
          <a class="btn btn-primary" :href="exportarInformePartido" role="button">
            Descargar⠀⠀<i class="fa-solid fa-download"></i>
          </a>
        </div>
      </div>
    </modal>
    <!-- MODAL telefono -->
    <modal v-if="screen.width < 991"
     
      name="modal-exportar-partido"
      :adaptive="true"
      :scrollable="true"
      :overflowX ="'scroll'"
      :clickToClose="true"
      :height="'auto'"
      :width="'90%'"
    >
      <div class="modal-header">
        <h4 style="margin: 0px">Exportar informe por partido</h4>
        <button
          @click="$modal.hide('modal-exportar-partido')"
          type="button"
          class="btn-close"
          style="background: none; border: none;"
          aria-label="Close"
        >
          <i class="fas fa-times fa-lg" style="color:#3c3c3c !important;"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ $t("fecha") }}</label>
            <datetime
              :value-zone="timezoneId"
              :auto="true"
              class="theme-numier"
              format="dd-MM-yyyy"
              :title="$t('fecha')"
              :placeholder="'Selecciona la fecha del día del partido'"
              :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
              input-class="form-control"
              v-model="diaExportacionPartido">
            </datetime>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="col-md-3">
          <a class="btn btn-primary" :href="exportarInformePartido" role="button">
            Descargar⠀⠀<i class="fa-solid fa-download"></i>
          </a>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
} from "element-ui";
import { VueToggles } from "vue-toggles";
import { mapState } from 'vuex';
import { Loading } from "element-ui";
import swal from "sweetalert2";
import ItemPedido from "../../Widgets/Delivery/ItemPedido";


export default {
  name: "Delivery",
  created() {
    this.screen.width = screen.width;
    this.screen.height = screen.height;

    const anchoPantalla = window.innerWidth;

    if (anchoPantalla <= 768) {
      this.movil = true;
    }

    if (this.sectores && this.$cookies.isKey("sectores")) {
      this.estadio = true;
    }

    this.$store.dispatch("setNameRoute", "Delivery");
    this.loading = Loading.service({ text: "Cargando..." });

    this.getBusiness();
    
    this.refrescarPedidos();
    
  },
  computed: {
    timezoneId() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    exportarInformePartido() {
      let day = new Date(this.diaExportacionPartido);

      day = day.getTime() / 1000;

      return (
        this.$store.getters.apiUrl +
        "/delivery/exportMatchOrders?idBusiness=" +
        this.idBusiness +
        "&date=" +
        day +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    ...mapState(["listaSectores", "sectores"]),
    urlExportExcel() {
      return (
        this.$store.getters.apiUrl +
        "/delivery/exportarExcelDeliveryV2?idBusiness=" +
        this.idBusiness +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    user() {
      return this.$store.state.xuser;
    },
    host() {
      const hostsCarta = {
        D: "http://192.168.0.44/www.numier.com/carta/api",
        S: "../apicartadev/carta/",
        P: "../apicarta/carta/",
      };
      return hostsCarta[this.$store.state.entorno];
    },
    textAlert() {
      let text = "";

      if (this.estado === 0 && this.numConfirmacion === 0) {
        text = this.$t("noHayPedidosPendientesDeConfirmacion");
      } else if (this.estado === 1 && this.numConfirmados === 0) {
        text = this.$t("noHayPedidosConfirmados");
      } else if (this.estado === 2 && this.numPreparando === 0) {
        text = this.$t("noHayPedidosEnPreparacion");
      } else if (this.estado === 3 && this.numPreparados === 0) {
        text = this.$t("noHayPedidosPreparados");
      } else if (this.estado === 4 && this.numEnReparto === 0) {
        text = this.$t("noHayPedidosEnReparto");
      } else if (this.estado === 5 && this.numFinalizado === 0) {
        text = this.$t("noHayPedidosTerminados");
      }

      return text;
    },
  },
  data() {
    return {
      listBusinesses: [],
      idBusiness: 0,

      estado: 0,
      listPedidos: [],
      listConfig: {},
      listPedidosRecogida: [],
      listPedidosDomicilio: [],
      listPedidoMesa: [],
      listPedidoLimbo: [],
      listOpcionesSinqro: [],
      recogerActivo: true,
      domicilioActivo: true,

      numConfirmacion: 0,
      numConfirmados: 0,
      numPreparando: 0,
      numPreparados: 0,
      numEnReparto: 0,
      numFinalizado: 0,

      detallesPedido: false,

      contador: 30,

      observacion: "",

      permiso: 1,

      audio: new Audio("static/sound/timbre.mp3"),

      //RESPUESTA DE PERMISO DE OPERARIO
      respuesta: false,
      panelMesas: false,
      panelRecogida: false,
      panelDomicilio: false,
      servicioActivo: false,
      tieneSinqro: false,
      tokenServerSinqro: "",
      tokenUserSinqro: "",
      pedidosSuspendidosDomicilio: false,
      pedidosSuspendidosRecoger: false,
      diaExportacionPartido: 0,
      configSonido: false,
      movil: false,

      estadio: false,
      
      // Datos para el v-model del tiempo del delivery los pillo todos por pillar
      configuracionCarta: {

        nombreMostrado: '',
        email: '',
        telefono: '',
        telefonoWhatapp: '',
        descripcion: '',
        tiempoMedio: '',
        takeawaytime:0,
        // tipoPedido: 0,
        // pedidoDirecto: 'T',
        gastoEnvio: '',
        pedidoMinimo: '',
        textoEntrega: '',
        textoPresentacion: '',
        textoFormasPago: '',
        direccion:'',
        estadio: false,
      },
      screen: {
        width: "",
        height: "",
      },
      listResumenAgencias: [
        /*{
          nombreAgencia: "Glovo",
          numeroPedidos: 15,
          total: 15.32
        },
        {
          nombreAgencia: "UberEats",
          numeroPedidos: 20,
          total: 35.32
        },
        {
          nombreAgencia: "JustEat",
          numeroPedidos: 48,
          total: 102.50
        },
        {
          nombreAgencia: "Numier PEDIDOS",
          numeroPedidos: 10,
          total: 15
        },*/
      ]
    };
  },
  components: {
    ItemPedido,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
  },
  beforeDestroy() {
    //QUITAR PETICION RECURSIVA
    this.contador = -10;
  },
  methods: {
    getResumenAgencias() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          estado: this.estado,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getResumenAgencias", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listResumenAgencias = response.data.result;
          } else {
            vm.respuesta = false;

            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    gestionarTemporal(pedido, tipo) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
          telefonoPedidoTemporal: pedido.clientData.telefono,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      let vm = this;

      this.axios
      .get(
        this.$store.getters.apiUrl + "delivery/consultarUltimosPedidos",
        config
      )
      .then(function(response) {
        const accion = tipo ? vm.$t("aceptarMinuscula") : vm.$t("eliminarMinuscula");
        let text = tipo
          ? vm.$t("estaAccionAnadiraUnPedidoEstaSeguro")
          : vm.$t("estaAccionNoSePuedeDeshacerEstaSeguro");
        let textoTelefonoSimilar = vm.$t("haHabidoUnPedidoConEsteTelefonoEnLasUltimas12Horas");

        swal({
          title: response.data.result ? textoTelefonoSimilar : "¿Quiere " + accion + " el pedido temporal?",
          text: text,
          footer: response.data.result ? vm.$t("interrogacionQuiere") + accion + vm.$t("elPedidoTemporalInterrogacion") : "",
          type: response.data.result ? "warning" : tipo ? "success" : "error",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: vm.$t("aceptar"),
          cancelButtonText: vm.$t("cancelar"),
          buttonsStyling: true,
        }).then((result) => {
          if (result.value) {
            //let vm = this;
            vm.loading = Loading.service({ text: vm.$t('cargando')});
            var config = {
              params: {
                jwt: vm.$store.getters.jwt,
                idBusiness: vm.idBusiness,
                idPedidoTemporal: pedido.id,
              },
              headers: { Authorization: "Bearer " + vm.$store.getters.jwt },
            };
            if (tipo) {

              pedido.clientData.idPedidoTemporal = pedido.id;

              pedido.eLista.forEach((item, index) => {
                if (item.mitades) {
                  item.mitades.mitad1.otraMitad = item.mitades.mitad2.id;
                  item.mitades.mitad2.otraMitad = item.mitades.mitad1.id;
                  item.mitades.mitad1.cantidad = item.cantidad;
                  item.mitades.mitad2.cantidad = item.cantidad;
                  item.mitades.mitad1.auxMitad = item.id;
                  item.mitades.mitad2.auxMitad = item.id;
                  item.borrar = 1;
                  pedido.eLista.push(item.mitades.mitad1);
                  pedido.eLista.push(item.mitades.mitad2);
                }
              });
              
              const arrayData = {
                client: pedido.clientData,
                lista: pedido.eLista.filter((el) => {
                  return !el.borrar;
                }),
                gastoenvio: pedido.gastoEnvio,
                pagado: true,
                total: pedido.total,
              };
              const headers = vm.$headers;

              vm.$http
                .post(
                  vm.host + "/insertPedido.php",
                  JSON.stringify(arrayData),
                  {
                    headers: headers,
                  }
                )
                .then((response) => {
                  vm.loading.close();
                  vm.getPedidos();
                  vm.postLogTemporal(pedido.id, tipo);
                  //vm.$modal.hide("modal-limbo");
                });
            } else {
              vm.axios
                .get(
                  vm.$store.getters.apiUrl + "delivery/eliminarPedidoTemporal",
                  config
                )
                .then(function(response) {
                  vm.loading.close();
                  vm.getPedidos();
                  vm.postLogTemporal(pedido.id, tipo);
                  //vm.$modal.hide("modal-limbo");
                });
            }
          }
        });
      });
    },
    postLogTemporal(idPedidoTemporal, tipo) {
      let vm = this;

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        jwt: vm.$store.getters.jwt,
        idBusiness: this.idBusiness,
        idPedidoTemporal: idPedidoTemporal,
        tipo: tipo
      };

      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/insertLogTemporal",
          params,
          config
        )
        .then(function(response) {
          
        });
    },

    cambioOpcionBusiness() {
      this.permisoCarta();
      /*this.getHora();
      this.getConfigCarta();
      this.getDatosConfiguracionCarta();*/
    },
    getHora() {
      let vm = this;
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      this.axios
        .get(this.$store.getters.apiUrl + "general/getHora", config)
        .then(function(response) {
          if (response.data.response) {
            if (response.data.result.idDistributor === "0") {
              vm.$store.dispatch("setHoraBusiness", 0);
            } else {
              vm.$store.dispatch(
                "setHoraBusiness",
                parseInt(response.data.result.horaDistribuidor)
              );
            }
          }
        });
    },
    getConfigTpv() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 17,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.configSonido = true;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    col(tipo) {
      let size = 0;

      let col = "";

      if (this.panelMesas) {
        size++;
      }
      if (this.panelRecogida) {
        size++;
      }
      if (this.panelRecogida) {
        size++;
      }

      if (tipo === 0) {
        col = this.panelRecogida ? "col-md-" + 12 / size : "col-md-0";
      } else if (tipo === 1) {
        col = this.panelRecogida ? "col-md-" + 12 / size : "col-md-0";
      } else {
        col = this.panelMesas ? "col-md-" + 12 / size : "col-md-0";
      }

      return col;
    },

    openModalEliminarPedido(idPedido, status, idSinqro) {
      swal({
        title: this.$t("estasSeguroDeEliminarElPedido"),
        text: this.$t("estaAccionNoSePuedeDeshacer"),
        type: "error",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siBorrarPedido"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.eliminarPedido(idPedido);
          if (vm.tieneSinqro && idSinqro != 0) {
            this.getOpcionesSinqro(idSinqro, status, true);
          }
        }
      });
    },

    abrirModalMesas(valor) {
      if (valor) {
        this.openModalCerrarMesas(true);
      } else {
        this.openModalCerrarMesas(false);
      }
    },
    openModalCerrarMesas(valor) {
      if (valor) {
        swal({
          title: this.$t("estasSeguroDeSuspenderElServicioEnMesas"),
          text: this.$t(
            "siSuspendeElServicioEnMesasNoEntraranMasPedidosEnMesaHastaActivarloDeNuevo"
          ),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("siSuspenderElServicioEnMesa"),
          cancelButtonText: this.$t("cancelar"),
          buttonsStyling: true,
        }).then((result) => {
          if (result.value) {
            this.cerrarServicioMesas(valor);
          }
        });
      } else {
        swal({
          title: this.$t("estasSeguroDeActivarElServicioEnMesas"),
          text: this.$t(
            "siActivaElServicioDeMesasVolveranAEntrarPedidosDeMesa"
          ),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("siActivarElServicioEnMesa"),
          cancelButtonText: this.$t("cancelar"),
          buttonsStyling: true,
        }).then((result) => {
          if (result.value) {
            this.cerrarServicioMesas(valor);
          }
        });
      }
    },
    openModalCerrarServicio(tipo, valor) {
      if (valor) {
        swal({
          title: this.$t("estasSeguroDeSuspenderElServicio"),
          text: this.$t(
            "siSuspendeElServicioNoEntraranMasPedidosHastaActivarloDeNuevo"
          ),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("siSuspenderElServicio"),
          cancelButtonText: this.$t("cancelar"),
          buttonsStyling: true,
        }).then((result) => {
          if (result.value) {
            this.cerrarServicio(tipo, valor);
          }
        });
      } else {
        swal({
          title: this.$t("estasSeguroDeActivarElServicio"),
          text: this.$t("siActivaElServicioVolveranAEntrarPedidos"),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("siActivarElServicio"),
          cancelButtonText: this.$t("cancelar"),
          buttonsStyling: true,
        }).then((result) => {
          if (result.value) {
            this.cerrarServicio(tipo, valor);
          }
        });
      }
    },
    getConfigCarta() {
      this.listConfig = {};
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          estado: this.estado,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getConfig", config)
        .then(function(response) {
          const config = response.data.result.configs;
          config.forEach((element) => {
            const el = {};
            el[element.nombre] = element.valor != 0;
            Object.assign(vm.listConfig, el);
            if (element.idConfig == 7) {
              vm.domicilioActivo = element.valor == 1 ? false : true;
            } else if (element.idConfig == 22) {
              vm.recogerActivo = element.valor == 1 ? false : true;
            } else if (element.idConfig == 18) {
              vm.servicioActivo = element.valor == 1 ? false : true;
            }
          });
          vm.pedidosSuspendidosDomicilio = vm.listConfig.cerrarPedidosDomicilio;
          vm.pedidosSuspendidosRecoger = vm.listConfig.cerrarPedidosRecoger;
          vm.servicioActivo = !vm.listConfig.barraCerrada;
        });
    },
    permisoCarta() {
      if (this.loading.visible == false){
        this.loading = Loading.service({ text: "Cargando..."});
      }
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          estado: this.estado,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getPermisoCarta", config)
        .then(function(response) {
          if (response.data.response) {
            if (response.data.result.permiso) {
              vm.getHora();
              vm.getDatosConfiguracionCarta();
              vm.getConfigCarta();
              vm.getConfigTpv();
              vm.getResumenAgencias();

              vm.permiso = response.data.result.permiso;

              vm.panelDomicilio = false;
              vm.panelMesas = false;
              vm.panelRecogida = false;

              vm.getPedidos();

              response.data.result.listCartas.forEach(function(x) {
                if (x.tiene_carta === "1") {
                  vm.panelDomicilio = true;
                }

                if (x.tiene_mesas === "1") {
                  vm.panelMesas = true;
                }

                if (x.tiene_pedidos === "1") {
                  vm.panelRecogida = true;
                }

                if (x.servicioActivo === "1") {
                  vm.servicioActivo = true;
                }

                if (x.tiene_sinqro) {
                  vm.tieneSinqro = true;
                }

                if (x.tokenServerSinqro) {
                  vm.tokenServerSinqro = x.tokenServerSinqro;
                }

                if (x.tokenUserSinqro) {
                  vm.tokenUserSinqro = x.tokenUserSinqro;
                }
              });
            } else {
              vm.permiso = response.data.result.permiso;
              vm.loading.close();
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {

          vm.listBusinesses = response.data.result;

          if (!vm.sectores && !vm.$cookies.isKey("sectores")) {
            if (vm.$store.getters.idBusiness) {
              vm.idBusiness = vm.$store.getters.idBusiness;
            } else {
              vm.idBusiness = response.data.result[0].id;
            }

            vm.permisoCarta();
            //console.log("No tiene sectores")
          } else {
            vm.buscarNegocioConCarta();            
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    buscarNegocioConCarta() {

      var config = {
          params: {
              jwt: this.$store.getters.jwt
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };
      var params = {
          listBusinesses: this.listBusinesses,
          jwt: this.$store.getters.jwt,
      };
      let vm = this;
      this.axios
        .post(this.$store.getters.apiUrl + "delivery/findBusinessesInfos", params, config)
        .then(function(response) {

          //Si llega respuesta
          if (response.data.response) {
            //Y es mayor a 0
            if (response.data.result.length > 0) {
              //Igualamos el primer negocio, ya que tendrá carta y la propia lista
              vm.idBusiness = response.data.result[0].id;
              vm.listBusinesses = response.data.result;
            } else {
              //Si no, no igualamos lista y le añadimos el primer idBusiness de la anterior lista
              vm.idBusiness = vm.listBusinesses[0].id;
            }

            vm.permisoCarta();
          }
          
        })
        .catch(function(error) {
          console.log(error);
        });
    },
// AQUI
    getDatosConfiguracionCarta(){
      var config = {
        params: {
          idBusiness: this.idBusiness,
          gestionPedidos: true,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm=this;
        this.axios
        .get(this.$store.getters.apiUrl + "delivery/getConfiguracionCarta", config)
        .then(function(response) {
          if (response.data.response) {

            if (response.data.result) {
              vm.respuesta=true;
              vm.configuracionCarta = response.data.result;
            }
          } else {
            vm.respuesta=false;
            swal({
              title: vm.$t('atencion'),
              text: response.data.message,
              confirmButtonClass: 'btn btn-info btn-fill',
              type: 'error'
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    restarTiempoEnvio(){
        this.configuracionCarta.takeawaytime = this.configuracionCarta.takeawaytime - 5
        this.editarConfiguracionCarta()
    },

    sumarTiempoEnvio(){
       this.configuracionCarta.takeawaytime = this.configuracionCarta.takeawaytime - (-5)
       this.editarConfiguracionCarta()
    }, 

    restarTiempoRecoger(){
      this.configuracionCarta.tiempoMedio = this.configuracionCarta.tiempoMedio - 5
      this.editarConfiguracionCarta()
    },

    sumarTiempoRecoger(){
      this.configuracionCarta.tiempoMedio = this.configuracionCarta.tiempoMedio - (-5)
      this.editarConfiguracionCarta()
    },

     editarConfiguracionCarta() {
      var config = {
          params: {
              jwt: this.$store.getters.jwt
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };
      var params = {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          configuracion:this.configuracionCarta
      };

      let vm = this;
      this.axios.post(this.$store.getters.apiUrl + 'delivery/' + 'editarConfiguracionCarta', params, config)
          .then(function (response) {
              vm.inProgress = false;

              if (response.data.response) {

                  vm.$notify({
                      message: vm.$t('datosGuardadosCorrectamente'),
                      icon: 'nc-icon nc-check-2',
                      timeout: 2000,
                      horizontalAlign: 'right',
                      verticalAlign: 'top',
                      type: 'success'
                  });


              } else {
                  swal({
                      title: vm.$t('atencion'),
                      text: response.data.message,
                      confirmButtonClass: 'btn btn-info btn-fill',
                      type: 'error'
                  });
              }
          }).catch(function (error) {
          console.log(error);
          vm.inProgress = false;
      });
    },

    getPedidos() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          estado: this.estado,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getPedidosDelivery", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listPedidosRecogida = response.data.result.listPedidosRecogida;
            vm.listPedidosDomicilio = response.data.result.listPedidosDomicilio;
            vm.listPedidoMesa = response.data.result.listPedidoMesa;
            vm.listPedidoLimbo = response.data.result.listPedidoLimbo;

            if (response.data.result.numConfirmacion !== 0) {
              if (response.data.result.numConfirmacion > vm.numConfirmacion) {
                vm.audio.play();
              }
            }

            vm.numConfirmacion = response.data.result.numConfirmacion;
            vm.numConfirmados = response.data.result.numConfirmados;
            vm.numPreparando = response.data.result.numPreparando;
            vm.numPreparados = response.data.result.numPreparados;
            vm.numEnReparto = response.data.result.numEnReparto;
            vm.numFinalizado = response.data.result.numFinalizado;

            vm.respuesta = true;
            vm.actualizarTiempo();
          } else {
            vm.respuesta = false;

            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
          vm.loading.close();
        });
    },
    actualizarTiempo() {
      //
      this.listPedidosDomicilio.forEach(pedido => {

        if (pedido.envioprogramadodate == 0) {
          let tiempoPedido = pedido.createdDate;
          let ahora = Date.now();
          ahora = (ahora / 1000).toFixed(0);
          let tiempoEstimado = pedido.tiempoEstimado;
          let horas = tiempoEstimado.substr(0, tiempoEstimado.indexOf('h'));
          horas = parseInt(horas) || 0;
          horas = horas * 3600;

          let minutos = tiempoEstimado.substr(tiempoEstimado.indexOf('h')+1, tiempoEstimado.length);
          minutos = minutos.substr(0, minutos.indexOf('m'));
          //console.log(minutos);
          minutos = parseInt(minutos) || 0;
          minutos = minutos * 60;
          
          tiempoEstimado = horas + minutos;
          //tiempoEstimado = tiempoEstimado.match(/\d+/)[0];
          tiempoEstimado = parseInt(tiempoEstimado) || 0;
          //console.log(tiempoEstimado);
          if (tiempoEstimado > 0) {
            
            //console.log((ahora - (tiempoPedido + tiempoEstimado)));
            // Comprobamos si el timestamp del pedido más el tiempoEstimado es mayor al momento de ahora
            if (tiempoPedido + tiempoEstimado < ahora) {

              pedido.colorTiempo = "rojo";

            //Comprobamos si el timestamp del pedido más el tiempoEstimado es menor al momento de ahora y si la resta de la suma de ambos es menor a 10 minutos
            } else if ((tiempoPedido + tiempoEstimado) - ahora <= 600) {
              
              pedido.colorTiempo = "amarillo";
            
            } else {

              pedido.colorTiempo = "gris";

            }
          }
        }
      });

      this.listPedidosRecogida.forEach(pedido => {

        if (pedido.envioprogramadodate == 0) {
          let tiempoPedido = pedido.createdDate;
          let ahora = Date.now();
          ahora = (ahora / 1000).toFixed(0);
          let tiempoEstimado = pedido.tiempoEstimado;
          let horas = tiempoEstimado.substr(0, tiempoEstimado.indexOf('h'));
          horas = parseInt(horas) || 0;
          horas = horas * 3600;

          let minutos = tiempoEstimado.substr(tiempoEstimado.indexOf('h')+1, tiempoEstimado.length);
          minutos = minutos.substr(0, minutos.indexOf('m'));
          //console.log(minutos);
          minutos = parseInt(minutos) || 0;
          minutos = minutos * 60;
          
          tiempoEstimado = horas + minutos;
          //tiempoEstimado = tiempoEstimado.match(/\d+/)[0];
          tiempoEstimado = parseInt(tiempoEstimado) || 0;
          //console.log(tiempoEstimado);

          if (tiempoEstimado > 0) {

            // Comprobamos si el timestamp del pedido más el tiempoEstimado es mayor al momento de ahora
            if (tiempoPedido + tiempoEstimado < ahora) {

              pedido.colorTiempo = "rojo";

            //Comprobamos si el timestamp del pedido más el tiempoEstimado es menor al momento de ahora y si la resta de la suma de ambos es menor a 10 minutos
            } else if ((tiempoPedido + tiempoEstimado) - ahora <= 600) {
              
              pedido.colorTiempo = "amarillo";
            
            } else {

              pedido.colorTiempo = "gris";

            }
          }
        }
      });
      

    },
    getOpcionesSinqro(idSinqro, status, eliminar) {
      var config = {
        headers: {
          "x-api-server-access-token": this.tokenServerSinqro,
          "x-api-user-access-token": this.tokenUserSinqro,
        },
      };
      let vm = this;
      this.axios
        .get(
          "https://api.sinqro.com/pos-app/v1/orders/" + idSinqro + "/actions",
          config
        )
        .then(function(response) {
          vm.listOpcionesSinqro = response.data;
          vm.updateStatusSinqro(idSinqro, status, eliminar);
        });
    },

    updateStatusSinqro(idSinqro, status, eliminar) {
      let tokenSinqro = "";
      let accionSinqro = "";
      let estadosSinqro = [
        "ACCEPT",
        "IN_PREPARATION",
        "READY",
        "DELIVERING",
        "DELIVERED",
      ];

      if (eliminar && status == 0) {
        this.listOpcionesSinqro.forEach((opcion) => {
          if (opcion.actionType == "CANCEL") {
            tokenSinqro = opcion.token;
            accionSinqro = opcion.actionType;
          }
        });
      } else {
        tokenSinqro = this.listOpcionesSinqro[0].token;
        accionSinqro = this.listOpcionesSinqro[0].actionType;
      }

      let statusSinqro = 0;
      if (!eliminar) {
        estadosSinqro.forEach(function(estado, i) {
          if (estado == accionSinqro) {
            statusSinqro = i;
          }
        });
      }

      if (status < 5 && (status >= statusSinqro || eliminar)) {
        var config = {
          headers: {
            "x-api-server-access-token": this.tokenServerSinqro,
            "x-api-user-access-token": this.tokenUserSinqro,
          },
        };
        var data = {
          token: tokenSinqro,
        };
        let vm = this;
        this.axios
          .post(
            "https://api.sinqro.com/pos-app/v1/orders/" + idSinqro + "/actions",
            data,
            config
          )
          .then(function(response) {
            if (!eliminar && accionSinqro != estadosSinqro[status]) {
              vm.getOpcionesSinqro(idSinqro, status, false);
            }
          });
      }
    },

    confirmarPedido(idPedido, status, idSinqro) {
      /*swal({
        title: "¿Seguro que quiere modificar el estado del pedido?",
        text: "Esta acción puede afectar a su recepción en el tpv",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Aceptar",
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if(result.value) {*/
          var config = {
            params: {
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };
          var params = {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
            idPedido: idPedido,
            status: status,
          };

          let vm = this;
          let controller = "confirmarPedido";
          this.axios
            .post(
              this.$store.getters.apiUrl + "delivery/" + controller,
              params,
              config
            )
            .then(function(response) {
              if (response.data.response) {
                vm.getPedidos();
                if (vm.tieneSinqro && idSinqro != 0) {
                  vm.getOpcionesSinqro(idSinqro, status - 1, false);
                }

                if (status === 1) {
                  vm.$notify({
                    message: vm.$t("pedidoAceptadoCorrectamente"),
                    icon: "nc-icon nc-check-2",
                    timeout: 2000,
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: "success",
                  });
                } else if (status === 2) {
                  vm.$notify({
                    message: vm.$t("pedidoEnPreparacion"),
                    icon: "nc-icon nc-check-2",
                    timeout: 2000,
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: "success",
                  });
                } else if (status === 3) {
                  vm.$notify({
                    message: vm.$t("pedidoPreparado"),
                    icon: "nc-icon nc-check-2",
                    timeout: 2000,
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: "success",
                  });
                } else if (status === 4) {
                  vm.$notify({
                    message: vm.$t("pedidoEnReparto"),
                    icon: "nc-icon nc-check-2",
                    timeout: 2000,
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: "success",
                  });
                } else if (status === 5) {
                  vm.$notify({
                    message: vm.$t("pedidoFinalizado"),
                    icon: "nc-icon nc-check-2",
                    timeout: 2000,
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: "success",
                  });
                } else if (status === 6) {
                  vm.$notify({
                    message: vm.$t("pedidoArchivado"),
                    icon: "nc-icon nc-check-2",
                    timeout: 2000,
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: "success",
                  });
                }
              } else {
                swal({
                  title: vm.$t("atencion"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              }
            })
            .catch(function(error) {
              console.log(error);
              vm.inProgress = false;
            });
        /*};
      });*/
    },
    cerrarServicioMesas(valor) {
      this.servicioActivo = valor ? false : true;

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
        valor: !this.servicioActivo, // envío lo contrario porque la configuración es barraCerrada
      };

      let vm = this;
      let controller = "cerrarServicioMesa";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("servicioActualizadoCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    cerrarServicio(tipo, valor) {
      if (tipo == "R") {
        this.pedidosSuspendidosRecoger = valor;
      } else {
        this.pedidosSuspendidosDomicilio = valor;
      }

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
        valor: valor,
        tipo: tipo,
      };
      let vm = this;
      let controller = "cerrarServicio";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("servicioActualizadoCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    showModalValidarVisita(observacion, idPedido) {
      swal({
        title: this.$t("estasSeguroDeEditarLaObservacion"),
        text: this.$t("estaOperacionNoSePuedeDeshacer"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siEditarObservacion"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.agregarObservacion(observacion, idPedido);
        }
      });
    },
    eliminarPedido(idPedido) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
        idPedido: idPedido,
      };

      let vm = this;
      let controller = "eliminarPedido";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.getPedidos();

            vm.$notify({
              message: vm.$t("pedidoEliminadoCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    agregarObservacion(observacion, idPedido) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
        idPedido: idPedido,
        observacion: observacion,
      };

      let vm = this;
      let controller = "agregarObservacion";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.$modal.hide("detalles-pedido-modal" + idPedido);
            vm.observacion = "";
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    refrescarPedidos() {
      if (this.contador === 0) {
        if (this.configSonido) {
          if (this.numConfirmacion > 0) {
            this.audio.play();
          }
        }

        this.contador = 30;
        this.getPedidos();
        this.refrescarPedidos();
      } else if (this.contador > 0) {
        setTimeout(() => {
          this.contador--;
          this.refrescarPedidos();
        }, 1000);
      } else {
      }
    },
  },
};
</script>
<style scoped>
.exportarReservas {
  margin-right: 2%;
}
.pedidosContainerButtonery {
  display: flex;
  margin-left: auto;
  height: fit-content;
  justify-content: flex-end;
}

.buttoneryHeader {
  align-items: flex-end;
}

.buttoneryTime {
  align-items: flex-end;
  border-radius: 0%;

}

.btnIcon {
  background-color: #f0f0f0;
  border-color: #D3D3D3;
  width: 45px;
  height: 45px;
  margin-left:1%;
  margin-right: 0%;
  padding-left: 0%;
  padding-right: 0%;
  border-top-right-radius: 0%;
  border-bottom-right-radius: 0%;
  cursor: context-menu;
}

.btnTime {
  background-color: #f0f0f0;
  border-color: #D3D3D3;
  width: 45px;
  height: 45px;
  margin-left:0px;
  margin-right: 0%;
  padding-left: 0%;
  padding-right: 0%;
  border-top-left-radius: 0%;
  border-bottom-left-radius: 0%;
}

.btnTogglePedidosContainer {
  display: flex;
  margin-left: auto;
  justify-content: flex-end;
  margin-bottom: 2%;
  margin-right: 1.5vw;
}

.btnTogglePedidosContainer span {
  margin-left: 10px;
}

.btnTogglePedidosItem {
  margin-right: 0.5vw;
}

.ebtnLimbo {
  display: flex;
  justify-content: center;
  height: fit-content;
  align-items: center;
  cursor: pointer;
  margin-right: 0.8vw;
  min-width: 195px;
}

.ebtnLimbo span {
  color: white;
  font-weight: 600;
}
tbody tr:hover {
  background-color: rgba(0, 153, 130, 0.2);
  cursor: pointer;
}

td div {
  padding: 12px 8px;
  color: #333;
}

.buttonsSearch:hover {
  cursor: pointer;
  background-color: rgba(0, 153, 130, 0.1);
}

.card {
  padding: 20px;
  margin-bottom: 5px;
}

.input-group button {
  height: 40px;
}

.botonTotal {
  border: 1px solid #28a745;
  color: #ffffff;
  background-color: #28a745;
  font-weight: 400;
  padding: 8px 16px;
  /* cursor: pointer; */
  margin-bottom: 5px;
  font-size: 14px;
  line-height: 1.42857143;
}

.tituloPedido {
  color: #1E22AA;
  font-family: "Numier", "Helvetica Neue", Arial;
}
.table {
  margin-left: 2%;
  margin-right: 2%;
  width: 96%;
}
.list-leave-active {
  transition: 1s;
}

.list-leave-to {
  opacity: 0;
}

.titlePedidos {
  background-color: #1E22AA;
  color: white;
  padding: 10px;
  font-size: 20px;
  margin-bottom: 5px;
}

.btnOculto {
  background-color: grey;
}

.btnDefault {
  background-color: #474747;
  border-color: #474747;
}

.btnPendientes {
  background-color: #a288e3;
  border-color: #a288e3;
}

.btnConfirmados {
  background-color: #23923d;
  border-color: #23923d;
}

.btnEnPreparacion {
  background-color: #ff9510;
  border-color: #ff9510;
}

.btnPreparados {
  background-color: #53385f;
  border-color: #53385f;
}

.btnEnReparto {
  background-color: #11bfe3;
  border-color: #11bfe3;
}

.btnFinalizados {
  background-color: #1E22AA;
  border-color: #1E22AA;
}

.form-control{
  height: 45px;
  width: 45px;
  /* padding-left:15px; */
}

#switchMesas,
#switchPedidos {
  float: left;
  margin-left: 25px !important;
}
@media only screen and (max-width: 768px) {

  .ebtnPedidos {
    width: 35%;
  }
  .btnIcon{
    margin-left: 7%;
    height: 45px;
    width: 45px;
  }
  .form-control{
    height: 45px;
    width: 45px;
  }
  .btnTime {
    background-color: #f0f0f0;
    border-color: #D3D3D3;
    width: 45px;
    height: 45px;
    margin-left:0px;
    margin-right: 0%;
    padding-left: 0%;
    padding-right: 0%;
    border-top-left-radius: 0%;
    border-bottom-left-radius: 0%;
  }
  .ebtnLimbo {
    min-width: 0px;
  }
  .pedidosContainerButtonery {
    padding-left: 1%
  }
  .table {
    width: 95%;
    margin-right: 5%;
    margin-left: 0px;
  }
  .row .form-group {
    width: 100%;
  }
  .ebtnPedidos {
    margin-left: 2%;
  }
  .botones, .btnTogglePedidosContainer {
    justify-content: center;
    width: 100%;
  }
  .botones span{
    margin: 1%;
    width: 100%;
  }
  #switchMesas {
    margin-left: 1% !important;
  }
  input:disabled {
    background: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Delivery.vue